import { t } from "i18next";

export type FormFieldConfig = {
    name: "name" | "vat" | "address1" | "address2" | "city" | "zip" | "state" | "country" | "email" | "phone";
    label: string;
    required?: boolean;
};

export const getCompanyGeneralFormFields = (isPaymentEnabled: boolean): readonly FormFieldConfig[] =>
    [
        {
            name: "name",
            label: t("companySettings.general.company_name", "Company name"),
            required: isPaymentEnabled,
        },
        {
            name: "vat",
            label: t(
                "companySettings.general.information.international_registration_number",
                "International Registration Number",
            ),
        },
        { name: "address1", label: t("companySettings.general.contact.address1", "Address 1") },
        { name: "address2", label: t("companySettings.general.contact.address2", "Address 2") },
        { name: "city", label: t("companySettings.general.contact.city", "City") },
        { name: "zip", label: t("companySettings.general.zip", "Zip code"), required: isPaymentEnabled },
        { name: "state", label: t("companySettings.general.contact.state", "State") },
        {
            name: "country",
            label: t("companySettings.general.contact.country", "Country"),
            required: isPaymentEnabled,
        },
        { name: "email", label: t("companySettings.general.email", "Email"), required: isPaymentEnabled },
        { name: "phone", label: t("companySettings.general.contact.phone", "Phone number") },
    ] as const;
